import React from 'react'
import PlayKaroLiveCasino from '../../components/PlayKaroLiveCasino/PlayKaroLiveCasino'

const PlayKaroLiveCasinoPage = () => <PlayKaroLiveCasino />

export default PlayKaroLiveCasinoPage
